
import { defineComponent, computed } from "vue";
import { useViewport } from "@travelata-libs/utils";

export default defineComponent({
    name: "ExclusiveBlock",
    setup() {
        const { isMobile } = useViewport();

        const defaultText = computed(() =>
            isMobile.value
                ? "Поймайте лучшую цену на тур"
                : "Поймайте лучшую цену на тур с высокой вероятностью подтверждения"
        );

        return {
            defaultText
        };
    }
});
